import { createContext } from 'react';
import useFormGuardController from '@/hooks/use-form-guard-controller';
import { useTranslation } from 'react-i18next';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { buttonVariants } from '@/components/ui/button';

export const FormGuardContext = createContext(null);

export default function FormGuardProvider({ children }) {
  const { t } = useTranslation();
  const {
    registration,
    dialogOpen,
    dialogCopy,
    setDialogOpen,
    handleDiscard,
    handleKeepEditing,
  } = useFormGuardController();

  return (
    <FormGuardContext value={registration}>
      {children}
      <AlertDialog open={dialogOpen} onOpenChange={setDialogOpen}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>
              {t(dialogCopy?.titleKey || 'common.unsavedChanges.title')}
            </AlertDialogTitle>
            <AlertDialogDescription>
              {t(
                dialogCopy?.descriptionKey ||
                  'common.unsavedChanges.description',
              )}
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleKeepEditing}>
              {t(dialogCopy?.keepKey || 'common.unsavedChanges.keepEditing')}
            </AlertDialogCancel>
            <AlertDialogAction
              className={buttonVariants({ variant: 'destructive' })}
              onClick={handleDiscard}
            >
              {t(
                dialogCopy?.discardKey ||
                  'common.unsavedChanges.discardChanges',
              )}
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </FormGuardContext>
  );
}
